module.exports = __webpack_public_path__ + "img/mockup_viberbm_cutoff.1a6d61e1.png";